import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import _isNil from "lodash/isNil.js";
function cov_1ymkl8lrj8() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountEmailForm.tsx";
  var hash = "407cc7374155f29f88d01cac75e86949f01b1b64";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountEmailForm.tsx",
    statementMap: {
      "0": {
        start: {
          line: 28,
          column: 25
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "1": {
        start: {
          line: 41,
          column: 44
        },
        end: {
          line: 41,
          column: 74
        }
      },
      "2": {
        start: {
          line: 42,
          column: 30
        },
        end: {
          line: 42,
          column: 60
        }
      },
      "3": {
        start: {
          line: 44,
          column: 36
        },
        end: {
          line: 44,
          column: 60
        }
      },
      "4": {
        start: {
          line: 46,
          column: 30
        },
        end: {
          line: 54,
          column: 5
        }
      },
      "5": {
        start: {
          line: 47,
          column: 18
        },
        end: {
          line: 47,
          column: 47
        }
      },
      "6": {
        start: {
          line: 48,
          column: 21
        },
        end: {
          line: 48,
          column: 58
        }
      },
      "7": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 53,
          column: 7
        }
      },
      "8": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 61
        }
      },
      "9": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 59,
          column: 11
        }
      },
      "10": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 26
        }
      },
      "11": {
        start: {
          line: 61,
          column: 25
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "12": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 25
        }
      },
      "13": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 65,
          column: 7
        }
      },
      "14": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 24
        }
      },
      "15": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 68,
          column: 7
        }
      },
      "16": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 28
        }
      },
      "17": {
        start: {
          line: 71,
          column: 33
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "18": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 40
        }
      },
      "19": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 75,
          column: 7
        }
      },
      "20": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 28
        }
      },
      "21": {
        start: {
          line: 80,
          column: 36
        },
        end: {
          line: 80,
          column: 58
        }
      },
      "22": {
        start: {
          line: 83,
          column: 23
        },
        end: {
          line: 83,
          column: 41
        }
      },
      "23": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 118,
          column: 6
        }
      },
      "24": {
        start: {
          line: 94,
          column: 14
        },
        end: {
          line: 94,
          column: 83
        }
      },
      "25": {
        start: {
          line: 122,
          column: 0
        },
        end: {
          line: 122,
          column: 50
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 7
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 40
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 46,
            column: 30
          },
          end: {
            line: 46,
            column: 31
          }
        },
        loc: {
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 46
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 56,
            column: 15
          }
        },
        loc: {
          start: {
            line: 56,
            column: 20
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 56
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 61,
            column: 25
          },
          end: {
            line: 61,
            column: 26
          }
        },
        loc: {
          start: {
            line: 61,
            column: 66
          },
          end: {
            line: 69,
            column: 5
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 71,
            column: 33
          },
          end: {
            line: 71,
            column: 34
          }
        },
        loc: {
          start: {
            line: 71,
            column: 47
          },
          end: {
            line: 76,
            column: 5
          }
        },
        line: 71
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 93,
            column: 22
          },
          end: {
            line: 93,
            column: 23
          }
        },
        loc: {
          start: {
            line: 94,
            column: 14
          },
          end: {
            line: 94,
            column: 83
          }
        },
        line: 94
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 31,
            column: 27
          },
          end: {
            line: 31,
            column: 31
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 32,
            column: 19
          },
          end: {
            line: 32,
            column: 37
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 30
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 53,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 53,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 51
      },
      "4": {
        loc: {
          start: {
            line: 52,
            column: 24
          },
          end: {
            line: 52,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 24
          },
          end: {
            line: 52,
            column: 43
          }
        }, {
          start: {
            line: 52,
            column: 47
          },
          end: {
            line: 52,
            column: 59
          }
        }],
        line: 52
      },
      "5": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 63
      },
      "6": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 66
      },
      "7": {
        loc: {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 13
          }
        }, {
          start: {
            line: 66,
            column: 17
          },
          end: {
            line: 66,
            column: 33
          }
        }, {
          start: {
            line: 66,
            column: 37
          },
          end: {
            line: 66,
            column: 48
          }
        }],
        line: 66
      },
      "8": {
        loc: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 73
      },
      "9": {
        loc: {
          start: {
            line: 73,
            column: 10
          },
          end: {
            line: 73,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 10
          },
          end: {
            line: 73,
            column: 30
          }
        }, {
          start: {
            line: 73,
            column: 34
          },
          end: {
            line: 73,
            column: 37
          }
        }, {
          start: {
            line: 73,
            column: 41
          },
          end: {
            line: 73,
            column: 57
          }
        }, {
          start: {
            line: 73,
            column: 61
          },
          end: {
            line: 73,
            column: 72
          }
        }],
        line: 73
      },
      "10": {
        loc: {
          start: {
            line: 83,
            column: 23
          },
          end: {
            line: 83,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 23
          },
          end: {
            line: 83,
            column: 31
          }
        }, {
          start: {
            line: 83,
            column: 35
          },
          end: {
            line: 83,
            column: 41
          }
        }],
        line: 83
      },
      "11": {
        loc: {
          start: {
            line: 94,
            column: 23
          },
          end: {
            line: 94,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 55
          },
          end: {
            line: 94,
            column: 57
          }
        }, {
          start: {
            line: 94,
            column: 60
          },
          end: {
            line: 94,
            column: 82
          }
        }],
        line: 94
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "407cc7374155f29f88d01cac75e86949f01b1b64"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ymkl8lrj8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ymkl8lrj8();
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useEffect, useState } from 'react';
import { Box, ValidatedTextInput } from '@opendoor/bricks-next';
import i18n from "../../i18n/index.mjs";
import { t } from "../../i18n/translationHelper.mjs";
import AccountFormControls from "./AccountFormControls.mjs";
import { Form } from "./shared.mjs";
var AccountEmailForm = (cov_1ymkl8lrj8().s[0]++, /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$showForgotPasswo = _ref.showForgotPassword,
    showForgotPassword = _ref$showForgotPasswo === void 0 ? (cov_1ymkl8lrj8().b[0][0]++, true) : _ref$showForgotPasswo,
    _ref$EmailInput = _ref.EmailInput,
    EmailInput = _ref$EmailInput === void 0 ? (cov_1ymkl8lrj8().b[1][0]++, ValidatedTextInput) : _ref$EmailInput,
    analyticsName = _ref.analyticsName,
    loading = _ref.loading,
    openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab,
    onSubmit = _ref.onSubmit,
    _ref$email = _ref.email,
    initialEmail = _ref$email === void 0 ? (cov_1ymkl8lrj8().b[2][0]++, '') : _ref$email;
  cov_1ymkl8lrj8().f[0]++;
  var _ref2 = (cov_1ymkl8lrj8().s[1]++, useState(initialEmail)),
    _ref3 = _slicedToArray(_ref2, 2),
    prefillEmail = _ref3[0],
    setPrefillEmail = _ref3[1];
  var _ref4 = (cov_1ymkl8lrj8().s[2]++, useState(initialEmail)),
    _ref5 = _slicedToArray(_ref4, 2),
    email = _ref5[0],
    setEmail = _ref5[1];
  var _ref6 = (cov_1ymkl8lrj8().s[3]++, useState(false)),
    _ref7 = _slicedToArray(_ref6, 2),
    hasError = _ref7[0],
    setHasError = _ref7[1];
  cov_1ymkl8lrj8().s[4]++;
  var maybePrefillEmail = function maybePrefillEmail() {
    cov_1ymkl8lrj8().f[1]++;
    var url = (cov_1ymkl8lrj8().s[5]++, new URL(window.location.href));
    var params = (cov_1ymkl8lrj8().s[6]++, new URLSearchParams(url.searchParams));

    // Update state on mount only if there is a query param override
    cov_1ymkl8lrj8().s[7]++;
    if (params.get('email')) {
      cov_1ymkl8lrj8().b[3][0]++;
      cov_1ymkl8lrj8().s[8]++;
      setPrefillEmail((cov_1ymkl8lrj8().b[4][0]++, params.get('email')) || (cov_1ymkl8lrj8().b[4][1]++, initialEmail));
    } else {
      cov_1ymkl8lrj8().b[3][1]++;
    }
  };
  cov_1ymkl8lrj8().s[9]++;
  useEffect(function () {
    cov_1ymkl8lrj8().f[2]++;
    cov_1ymkl8lrj8().s[10]++;
    maybePrefillEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  cov_1ymkl8lrj8().s[11]++;
  var handleSubmit = function handleSubmit(e) {
    cov_1ymkl8lrj8().f[3]++;
    cov_1ymkl8lrj8().s[12]++;
    e.preventDefault();
    cov_1ymkl8lrj8().s[13]++;
    if (!hasError) {
      cov_1ymkl8lrj8().b[5][0]++;
      cov_1ymkl8lrj8().s[14]++;
      onSubmit(email);
    } else {
      cov_1ymkl8lrj8().b[5][1]++;
    }
    cov_1ymkl8lrj8().s[15]++;
    if ((cov_1ymkl8lrj8().b[7][0]++, ref) && (cov_1ymkl8lrj8().b[7][1]++, 'current' in ref) && (cov_1ymkl8lrj8().b[7][2]++, ref.current)) {
      cov_1ymkl8lrj8().b[6][0]++;
      cov_1ymkl8lrj8().s[16]++;
      ref.current.focus();
    } else {
      cov_1ymkl8lrj8().b[6][1]++;
    }
  };
  cov_1ymkl8lrj8().s[17]++;
  var handleValidityChange = function handleValidityChange(validity) {
    cov_1ymkl8lrj8().f[4]++;
    cov_1ymkl8lrj8().s[18]++;
    setHasError(validity !== 'valid');
    cov_1ymkl8lrj8().s[19]++;
    if ((cov_1ymkl8lrj8().b[9][0]++, validity !== 'valid') && (cov_1ymkl8lrj8().b[9][1]++, ref) && (cov_1ymkl8lrj8().b[9][2]++, 'current' in ref) && (cov_1ymkl8lrj8().b[9][3]++, ref.current)) {
      cov_1ymkl8lrj8().b[8][0]++;
      cov_1ymkl8lrj8().s[20]++;
      ref.current.focus();
    } else {
      cov_1ymkl8lrj8().b[8][1]++;
    }
  };

  // Disable email suggestions if locale is Spanish simply because
  // we don't have an easy way to translate suggestions in bricks-next yet
  var disableEmailSuggestions = (cov_1ymkl8lrj8().s[21]++, i18n.language === 'es');

  // Disable the form if it has an error or if email is not set.
  var isDisabled = (cov_1ymkl8lrj8().s[22]++, (cov_1ymkl8lrj8().b[10][0]++, hasError) || (cov_1ymkl8lrj8().b[10][1]++, !email));
  cov_1ymkl8lrj8().s[23]++;
  return /*#__PURE__*/React.createElement(Form, {
    onSubmitCapture: handleSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "$4x"
  }, /*#__PURE__*/React.createElement(EmailInput, {
    id: "email-login-input",
    analyticsName: "".concat(analyticsName, "-email"),
    required: true,
    title: t('email'),
    ref: ref,
    getValue: function getValue(value) {
      cov_1ymkl8lrj8().f[5]++;
      cov_1ymkl8lrj8().s[24]++;
      return setEmail(_isNil(value.unformattedValue) ? (cov_1ymkl8lrj8().b[11][0]++, '') : (cov_1ymkl8lrj8().b[11][1]++, value.unformattedValue));
    },
    allowSuggestions: !disableEmailSuggestions,
    onValidationChange: handleValidityChange,
    format: "emailAddress",
    size: "medium",
    prefilledValue: prefillEmail,
    customErrorMessages: {
      fieldRequired: t('fieldRequiredError'),
      invalidEmail: t('invalidEmailError'),
      invalidPhoneNumber: t('invalidPhoneError')
    }
  }), /*#__PURE__*/React.createElement(AccountFormControls, {
    actionText: t('continueWithEmail'),
    analyticsName: "".concat(analyticsName, "-email"),
    loading: loading,
    disabled: isDisabled,
    openForgotPasswordInNewTab: openForgotPasswordInNewTab,
    submitA11yProps: {
      'aria-label': ''
    },
    showForgotPassword: showForgotPassword
  })));
}));
cov_1ymkl8lrj8().s[25]++;
AccountEmailForm.displayName = 'AccountEmailForm';
export default AccountEmailForm;
//# sourceMappingURL=AccountEmailForm.mjs.map